import React, { useState } from "react";
import axios from "axios";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import "../styles/ForgotPassword.css";

export default function ForgotPassword() {
  const [step, setStep] = useState(1);
  const [email, setEmail] = useState("");
  const [otp, setOtp] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [tempToken, setTempToken] = useState("");
  const navigate = useNavigate();

  // Step 1: Send OTP
  const handleSendOtp = async (e) => {
    e.preventDefault();
    if (!email.includes("@")) return toast.error("Enter a valid email.");

    setLoading(true);
    try {
      const res = await axios.post("https://globisun-app.onrender.com/api/auth/forgot-password", { email });
      toast.success(res.data.msg || "OTP sent to your email.");
      setStep(2);
    } catch (err) {
      toast.error(err.response?.data?.msg || "Failed to send OTP.");
    } finally {
      setLoading(false);
    }
  };

  // Step 2: Verify OTP
  const handleVerifyOtp = async (e) => {
    e.preventDefault();
    if (!otp) return toast.error("Enter the OTP.");

    setLoading(true);
    try {
      const res = await axios.post("https://globisun-app.onrender.com/api/auth/verify-reset-otp", {
        email,
        otp,
      });
      toast.success(res.data.msg || "OTP verified.");
      setTempToken(res.data.tempToken); // store token for password reset
      setStep(3);
    } catch (err) {
      toast.error(err.response?.data?.msg || "Invalid or expired OTP.");
    } finally {
      setLoading(false);
    }
  };

  // Step 3: Reset Password
  const handleResetPassword = async (e) => {
    e.preventDefault();
    if (password.length < 6) return toast.error("Password must be at least 6 characters.");

    setLoading(true);
    try {
      const res = await axios.post("https://globisun-app.onrender.com/api/auth/reset-password", {
        token: tempToken,
        password,
      });
      toast.success(res.data.msg || "Password reset successful!");
      navigate("/login"); // auto-redirect to login
    } catch (err) {
      toast.error(err.response?.data?.msg || "Failed to reset password.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="forgot-step">
      {step === 1 && (
        <>
          <h2>Forgot Password</h2>
          <p>Enter your email to receive an OTP.</p>
          <form onSubmit={handleSendOtp}>
            <input
              type="email"
              placeholder="Email address"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              disabled={loading}
            />
            <button type="submit" disabled={loading}>
              {loading ? "Sending..." : "Send OTP"}
            </button>
          </form>
        </>
      )}

      {step === 2 && (
        <>
          <h2>Verify OTP</h2>
          <p>Enter the OTP sent to your email.</p>
          <form onSubmit={handleVerifyOtp}>
            <input
              type="text"
              placeholder="Enter OTP"
              value={otp}
              onChange={(e) => setOtp(e.target.value)}
              required
              disabled={loading}
            />
            <button type="submit" disabled={loading}>
              {loading ? "Verifying..." : "Verify OTP"}
            </button>
          </form>
        </>
      )}

      {step === 3 && (
        <>
          <h2>Reset Password</h2>
          <p>Enter your new password.</p>
          <form onSubmit={handleResetPassword}>
            <input
              type="password"
              placeholder="New password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              disabled={loading}
            />
            <button type="submit" disabled={loading}>
              {loading ? "Resetting..." : "Reset Password"}
            </button>
          </form>
        </>
      )}
    </div>
  );
}
